import React from "react";

const ChallengeLegend = props => {
    return (
        <div className="ChallengeLegend">
            {props.legendItems.map((item, index) => {
                return (
                    <div key={index} className="legend-item">
                        <h3 className="component-headline no-page-break">{item[0]}</h3>
                        <p>{item[1]}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default ChallengeLegend;


// WEBPACK FOOTER //
// ./src/components/ads/app/appchallengecenter/ChallengeLegend.js